import { FC } from "react";
import Grid, { GridProps } from "@mui/material/Grid";

/**
 * Grid container with a spacing suitable for metadata components in the media view page (e.g. presenters, attachments, etc.)
 * Use it to ensure that the columns for all components are aligned.
 */
export const MediaMetadataGridContainer: FC<GridProps> = ({ children, ...props }) => {
    return <Grid container rowSpacing={2} columnSpacing={2} {...props}>
        {children}
    </Grid>;
};

/**
 * Grid item with a width suitable for metadata components in the media view page (e.g. presenters, attachments, etc.)
 * Use it to ensure that the columns for all components are aligned.
 */
export const MediaMetadataGridItem: FC = ({ children }) => {
    // 3 columns on desktop, 2 columns on tablets, 1 column on mobile
    return <Grid item xs={12} sm={6} lg={4}>
        {children}
    </Grid>;
};
